import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../core/services/auth.service';

export interface SeekerProfile {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  lang?: string;
  role: string;
  profileImage?: string;
  ShowProfile: string;
  aboutMe?: string;

  notificationSettings: { email: boolean; app: boolean };
  expectedBudget?: number;
  preferredArea?: string;
  propertyType?: string;
  purposeOfSearch?: string;
  createdAt: string;
  updatedAt: string;
}

export interface SeekerProfileResponse {
  resProfile: SeekerProfile;
}

export interface UpdateSeekerProfileResponse {
  message: string;
  resProfile: SeekerProfile;
}

@Injectable({ providedIn: 'root' })
export class SeekerProfileService {
  private baseUrl = environment.api.baseUrl;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  private headers(): HttpHeaders | undefined {
    const token = this.authService.getAccessToken();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;
  }

  getProfile(): Observable<SeekerProfileResponse> {
    return this.http.get<SeekerProfileResponse>(`${this.baseUrl}/seeker/profile`, {
      headers: this.headers(),
    });
  }

  updateProfile(formData: FormData): Observable<UpdateSeekerProfileResponse> {
    return this.http.patch<UpdateSeekerProfileResponse>(`${this.baseUrl}/seeker`, formData, {
      headers: this.headers(),
    });
  }
}
